module.exports = __webpack_public_path__ + "img/made-with-bulma--semiwhite.52eb1b1c.png";